export default __webpack_public_path__ + "static/media/mma-certified.7cfbd03f.svg";